import { TableHeaderKey } from "@/views/YourQuotes/types";
import { ref } from "vue";

export function useQuoteColumnInfo() {
    const showSlideout = ref(false);
    const slideoutKey = ref<TableHeaderKey | null>(null);

    function showMoreInfoForColumn(key: TableHeaderKey) {
        showSlideout.value = true;
        slideoutKey.value = key;
    }

    return { showSlideout, slideoutKey, showMoreInfoForColumn };
}
